<template lang="pug">
    .fk-input-container
        .wrapper(
            v-for="(input, index) in length"
            @click="focusActiveInput()"
        )
            input(
                :id="generateInputId(index)"
                :ref="generateInputId(index)"
                maxlength="1"
                :style="{ fontSize: fkFontSize, borderBottom: fkInputColor(index), color: fontColor, width: fkWidth }"
                v-model="inputValues[index]"
                :disabled="disabled(index)"
                @paste.prevent="handlePastedValues"
                @keypress="onKeyPress($event)"
                @input="onInput(index)"
                contenteditable="true"
                :key="index"
                type="number"
            )
        v-btn(flat icon @click="clear()" v-if="showClear")
            v-icon cancel
</template>

<script>
export default {
    props: {
        length: {
            type: Number,
            required: true
        },
        fontSize: {
            type: Number,
            default: 22,
            required: false
        },
        inputColor: {
            type: String,
            default: '#42b983',
            required: false
        },
        fontColor: {
            type: String,
            default: '#444444',
            required: false
        },
        allowPaste: {
            type: Boolean,
            default: true,
            required: false
        }
    },
    data() {
        return {
            inputValues: []
        }
    },
    computed: {
        fkFontSize() {
            return `${this.fontSize}px`
        },
        fkWidth() {
            const width = this.fontSize + 8
            return `${width}px`
        },
        showClear() {
            return this.inputValues.length && this.inputValues.some(it => !!it)
        }
    },
    watch: {
        inputValues: function(val) {
            if (val && !val.length || val.every(it => !it)) {
                this.$nextTick(() => {
                    this.focusInput(0)
                })
            }
        }
    },
    mounted: function() {
        this.focusInput(0)
    },
    methods: {
        generateInputId(index) {
            return `fk_${index + 1}`
        },
        fkInputColor(index) {
            const color = this.inputValues[index] ? this.inputColor : '#000000'
            return `3px solid ${color}`
        },
        handleInputFocus(index) {
            const nextInput = this.$refs[`fk_${index + 2}`] && this.$refs[`fk_${index + 2}`][0]

            if (this.inputValues[index] && nextInput) {
                this.$nextTick(() => {
                    nextInput.focus()
                })
            }
        },
        handlePastedValues(event) {
            if (this.allowPaste) {
                const pastedValue = event.clipboardData.getData('text/plain')
                const splitValues = pastedValue.split('')
                const _this = this
                for (let i = 0; i < this.length; i++) {
                    _this.updateInputValue(i, splitValues[i])
                }
                const [lastInput] = this.$refs[`fk_${this.length}`]
                lastInput.focus()
            }
        },
        updateInputValue(index, value) {
            this.$set(this.inputValues, index, value)
        },
        onKeyPress(event) {
            if (!/^[0-9]$/i.test(event.key)) {
                event.preventDefault()
            }
        },
        onInput(index) {
            this.$emit('input', this.inputValues.join(''))
            this.handleInputFocus(index)
        },
        focusInput(index) {
            this.$refs[`fk_${index + 1}`][0].focus()
        },
        focusActiveInput() {
            for (let i = 0; i < this.length; i++) {
                const input = this.$refs[`fk_${i + 1}`] && this.$refs[`fk_${i + 1}`][0]

                if (input && input.disabled === false) {
                    this.focusInput(i)
                    break
                }
            }
        },
        clear() {
            this.inputValues = []
            this.$emit('onClose')
        },
        disabled(index) {
            return this.inputValues[index] || !this.inputValues[index] && !this.inputValues[index - 1] && index != 0
        }
    }
}
</script>

<style lang="scss" scoped>
    .fk-input-container {
        display: block;
        margin: 20px auto;
        display: flex;
        align-items: center;
        width: max-content;

        .wrapper {
            margin-left: 10px;

            &:first-child { margin-left: 0; }

            input {
                border: none;
                text-align: center;

                &:focus { outline: none; }
            }
        }
    }

    .v-btn {
        position: absolute;
        margin: 0;
        right: -50px;
        top: 50%;
        transform: translateY(-45%);
    }
    .fk-input-container {
        position: relative;
    }

    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    input[type=number] {
        -moz-appearance:textfield;
    }
</style>
